import { FC, Fragment, useEffect, useState } from 'react';

import { Flex, Group, Space, Table, Text, Title, UnstyledButton } from '@mantine/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Modal, Select, TextInput, Tooltip } from '@common/components';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getLastWebsiteAudit } from 'src/store/siteList';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { apiInstance } from 'src/services';
import { shallowEqual } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { fetchLatestDashboard, fetchSiteDashboard, getDashbardsList, getOwnCompanies, ISiteDashboardsData, setSelectedCompanyofDashborad, setSelectedDashboard, setSelectedDashboardSuccess } from 'src/store';
import ExportButton from '../ExportButton';
import { Bar, Doughnut, Line, Pie } from 'react-chartjs-2';
import { SemiCircleProgress } from '../progressBars';
import LineChart from '../LineChart';
import { CHART_OPTIONS } from '../LineChart/constants';
import { ComplianceScoreCard } from '../dashboardGraphs/ScoreProgress/components';
import { ReactComponent as NoDataGraph } from 'src/assets/svg/no-data-graph.svg';
import { UsageChart } from '../UsageCharts';
import { ChartOptions } from 'chart.js';
import { useAlert } from '@common/hooks';
import CardComponent from '../CardComponent';
import GaugeChart from 'react-gauge-chart';
import styles from './styles.module.scss';
import { LineChartOptionComponent, PieChartOptionComponent, SemicircleOption, MultipleBarHorizantalOption, BarChartOptionComponent, GaugeChartOptionComponent, WebsiteScoreChartOptionComponent, ScanProgressChartOptions, PieChartOptionComponentPriority } from './components/ChartOptionsPerType';
import { dashboardType } from 'src/pages/DashboardPage';
import DisplayChartsByDashboard from './components/DisplayChartsByDashboard';
import "./Overview.css"
import { QuestionCircle } from '@geist-ui/icons';
import { wcag_guidelines } from 'src/constants/wcag_guidelines';

interface Props {
  // dashboardsList : Array<dashboardType>
  accessibilityScoreProgress: {
    target: number;
    critical: number;
    actual:
    | {
      date: string;
      value: number;
    }[]
    | undefined;
  } | null;
  complianceScore: number;
  complianceLevel: string;
  description: string;
  criteriaPassed: number;
  criteriaNotTested: number;
  criteriaFailed: number;
  issuesCountByPriority: {
    warning: number,
    medium: number,
    low: number,
    high: number,
    critical: number
  };
  numberOfIssues: number;
  closedIssues: number;
  newsIssues: number;
  openIssues: number;
  commonIssues: {
    [key: string]: {
      [key: string]: number
    };
  };
  commonSeccess: {
    [key: string]: {
      [key: string]: number
    };
  };
  webSitesData: Array<SiteListType>;
  issuesCountOverTime: {
    actual: Array<{
      date: string,
      totalIssues: number,
      closedIssues: number,
      openIssues: number
    }>
  },
  ialabsScore: number,
  showDefaultDash?: boolean
}


interface GridItem {
  id: number,
  popover?: string,
  title: string,
  content: React.ReactElement,
  table?: React.ReactElement,
}
const SiteList: FC<Props> = ({

  // dashboardsList,
  accessibilityScoreProgress,
  complianceScore,
  complianceLevel,
  description,
  criteriaPassed,
  criteriaNotTested,
  criteriaFailed,
  issuesCountByPriority,
  numberOfIssues,
  closedIssues,
  newsIssues,
  openIssues,
  commonIssues,
  commonSeccess,
  webSitesData,
  issuesCountOverTime,
  ialabsScore,
  showDefaultDash = false

}: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery('(max-width: 991px)');
  const [t] = useTranslation('siteList');
  const [c] = useTranslation('common');
  const [addSite, setAddSite] = useState(false);
  const { websiteCount, company_id, company_name } = useAppSelector((state) => state.user.data);
  const loading = useAppSelector((state) => state.siteList.loading);
  // const sitesArray = useAppSelector((state) => state.siteList.data);
  const { websites } = useAppSelector((state) => state.payment.data.metadata);
  const { isLoading } = useAppSelector((state) => state.payment);
  const canDisplayButton = !(websiteCount >= Number(websites)) && !isLoading;
  const { data } = useAppSelector((state) => state.user, shallowEqual);
  const { companyWebsites } = useAppSelector((state) => state.organization, shallowEqual);
  const { latestDashboard } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { dashboardsListLoading, dashboardsList, dashboard, loading: dahboardLoading, setSelectedCompany, loadingSetSelectedCompany } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
  const { lastSiteAuditedData, loadinglastSiteAudited, lastSiteAuditedError } = useAppSelector((state) => state.siteList, shallowEqual);

  const [j] = useTranslation('accessibilityDashboard');
  const { data: siteDashboards } = useAppSelector((state) => state.siteDashboards, shallowEqual);
  // const dashboard = useAppSelector((state) => state.siteDashboards, shallowEqual);
  const [dashboardSelec, setDashboardSelec] = useState(dashboard?.id ?? 'default')

  const [showDefault, setShowDefault] = useState(showDefaultDash)
  // const groupedData = groupValues(data?.accessibilityScoreProgress.actual);
  const groupedData =
    accessibilityScoreProgress?.actual?.length && accessibilityScoreProgress?.actual?.length > 20
      ? accessibilityScoreProgress.actual.slice(
        accessibilityScoreProgress.actual.length - 20,
        accessibilityScoreProgress.actual.length,
      )
      : accessibilityScoreProgress?.actual;
  const labels = groupedData?.map((item) => item.date);
  const values = groupedData?.map((item) => item.value);
  const isMobile2 = useMediaQuery('(max-width: 768px)');


  const { loadingClientJoinOrganization, getOwnCompaniesdata } = useAppSelector((state) => state.organization, shallowEqual);


  const CHART_DATA = {
    labels,
    datasets: [
      {
        label: t('CompliantScore'),
        data: values,
        borderColor: '#5B5EFF',
        backgroundColor: '#5B5EFF',
        pointBackgroundColor: '#5B5EFF',
        borderWidth: 4,
        pointBorderWidth: 6,
        labelBorderWidth: 4,
      },
      {
        label: t('Target'),
        // data: Array.from({ length: labels?.length as number }).fill(accessibilityScoreProgress?.target),
        data: Array.from({ length: labels?.length as number }).fill(10),
        borderColor: '#035e11b0',
        backgroundColor: '#035e11b0',
        borderWidth: 4,
        fill: false,
        lineTension: 0,
        pointBackgroundColor: '#035e11b0',
        pointHoverRadius: 0,
        pointRadius: 0,
        pointHitRadius: 0,
        borderDash: [10, 5],
      },
      {
        label: t('Critical'),
        // data: Array.from({ length: labels?.length as number }).fill(siteDashboards?.accessibilityScoreProgress?.critical),
        data: Array.from({ length: labels?.length as number }).fill(10),
        borderColor: '#da604e',
        backgroundColor: '#da604e',
        pointBackgroundColor: '#da604e',
        borderWidth: 4,
        fill: false,
        lineTension: 0,
        pointRadius: 0,
        pointHitRadius: 0,
        borderDash: [10, 5],
      },
    ],
  };

  const CHART_DATA_IMPACT = {
    labels: ['Low Impact', 'Medium Impact', 'High Impact', 'Critical Impact'], // Accessibility impact labels
    datasets: [
      {
        label: 'Low Impact',
        data: [70, 50, 30, 10], // Values for each impact level
        borderColor: '#5B5EFF',
        backgroundColor: '#5B5EFF',
        pointBackgroundColor: '#5B5EFF',
        borderWidth: 4,
        pointBorderWidth: 6,
        labelBorderWidth: 4,
      },
      {
        label: 'Medium Impact',
        data: [80, 60, 40, 20], // Target values for each impact level
        borderColor: '#035e11b0',
        backgroundColor: '#035e11b0',
        borderWidth: 4,
        fill: false,
        lineTension: 0,
        pointBackgroundColor: '#035e11b0',
        pointHoverRadius: 0,
        pointRadius: 0,
        pointHitRadius: 0,
        borderDash: [10, 5],
      },
      {
        label: 'High Impact',
        data: [10, 20, 30, 40], // Critical values for each impact level
        borderColor: '#da604e',
        backgroundColor: '#da604e',
        pointBackgroundColor: '#da604e',
        borderWidth: 4,
        fill: false,
        lineTension: 0,
        pointRadius: 0,
        pointHitRadius: 0,
        borderDash: [10, 5],
      },
      {
        label: 'Critical Impact',
        data: [10, 20, 30, 40], // Critical values for each impact level
        borderColor: '#2A2B4B',
        backgroundColor: '#2A2B4B',
        pointBackgroundColor: '#2A2B4B',
        borderWidth: 4,
        fill: false,
        lineTension: 0,
        pointRadius: 0,
        pointHitRadius: 0,
        borderDash: [10, 5],
      },
    ],
  };


  if (labels?.length === 1) {
    CHART_DATA.labels?.push('');
    // CHART_DATA.datasets[2].data?.push(accessibilityScoreProgress?.critical as number);
    // CHART_DATA.datasets[1].data?.push(accessibilityScoreProgress?.target as number);

    CHART_DATA.datasets[2].data?.push(10);
    CHART_DATA.datasets[1].data?.push(10);
  }


  // const hasPermission =   data.profile_status == "user" ? (data.userPermission?.includes('billing') ? true : false )  : true   ;
  const navigate = useNavigate()
  const navigateToPayment = (): void => {
    // if(!hasPermission){
    //       return;
    //   }
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };

  const changeFormState = (): void => setAddSite(!addSite);
  async function handleSelectedSite(siteId: string) {

    if (!companyWebsites?.data?.sitesResult) return
    const site = companyWebsites?.data?.sitesResult.find((site: any) => site.id === siteId)
    if (!site) return
    navigate(`/dashboard/${site.site_id}/issues/automated-audit?siteUUID=${site?.id}&pageNumber=1`)
  }

  const selecDashboardData = [
    {
      label: 'Default',
      value: 'default'
    },
    {
      label: 'Example 1',
      value: 'Example1'
    },
  ]


  const [opened, { open, close }] = useDisclosure(false);
  const [openedEditDashboard, { open: openEditDashoard, close: closeEditDashboard }] = useDisclosure(false);
  const [openedCreatChart, { open: openCreateChart, close: closeCreateChart }] = useDisclosure(false);
  const [openedDelete, { open: openDelete, close: closeDelete }] = useDisclosure(false);
  // useEffect(() => {
  //   dispatch(getLastWebsiteAudit());
  // }, []);

  useEffect(() => {
    if (lastSiteAuditedData) {
      const id = lastSiteAuditedData?.data?.siteData?.body?.lastUpdatedWebsite?.site_id
      dispatch(fetchLatestDashboard({ id }));
      dispatch(fetchSiteDashboard({ siteId: id, tenantId: data.tenantId }));

    }
  }, [lastSiteAuditedData, data.tenantId])

  // State for form values
  const [chartType, setChartType] = useState<string | null>('line');
  const [isCompany, setIsCompany] = useState<string>('company'); // Default to company
  const [permission, setPermission] = useState<string>('everyone'); // Default to 'everyone'
  const [chartPosition, setChartPosition] = useState<string>('topRight'); // Default to 'everyone'
  // const [modelName, setModelName] = useState("")
  const [newChartName, setNewChartName] = useState("")
  const [zoomLevel, setZoomLevel] = useState('md'); // Default is 'md'


  const [createDashboardLoading, setCreateDashboardLoading] = useState(false)
  const [dashboardName, setNewDashboardName] = useState("")
  const [newEditedNameDashboard, SetNewEditedNameDashboard] = useState("")
  const handleCreateDashboard = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      setCreateDashboardLoading(true)
      const response = await apiInstance.post(`reporttool/dashboard/dashboards`, {
        dashboardName: dashboardName
      });

      if (response?.data?.dashboardName == dashboardName) {
        dispatch(getDashbardsList({

          submitCallback: (data: any) => {
            const dash = data && data?.find((d: any) => d.dashboardName == response?.data?.dashboardName)
            if (dash?.id) {
              dispatch(setSelectedDashboard({ dashboard_id: dash?.id }))
            }
          }
        }))
        close()
        showAlert({
          id: response?.data?.id,
          title: 'Create Dashboard',
          message: `${response?.data?.dashboardName} Has Been Added Successfully.`,
          variant: 'success',
          autoClose: 2000
        });
        return
      }

      close()
      showAlert({
        id: 'error-creating',
        title: 'Create Dashboard Faild',
        variant: 'error',
        autoClose: 2000
      });
    } catch (error) {
      console.log(`Create Dashboard Faild : ${error}`);
    } finally {
      setNewDashboardName("")
      setCreateDashboardLoading(false)
    }
    // close(); // Close the modal after submission
  };
  const handleEditDashboard = async (event: React.FormEvent) => {
    event.preventDefault();


    try {
      setCreateDashboardLoading(true)
      const response = await apiInstance.put(`reporttool/dashboard/dashboards/${dashboard?.id}`, {
        dashboardName: newEditedNameDashboard
      });
      if (response?.data?.dashboardName == newEditedNameDashboard) {
        dispatch(getDashbardsList({}))
        closeEditDashboard()
        showAlert({
          id: response?.data?.id,
          title: 'Update Dashboard',
          message: `${response?.data?.dashboardName} Has Been Updated Successfully.`,
          variant: 'success',
          autoClose: 2000
        });
        return
      }

      closeEditDashboard()
      showAlert({
        id: 'error-creating',
        title: 'Update Dashboard Faild',
        variant: 'error',
        autoClose: 2000
      });
    } catch (error) {
    } finally {
      setNewDashboardName("")
      setCreateDashboardLoading(false)
    }





    // close(); // Close the modal after submission
  };

  const handleCreateChart = async (event: React.FormEvent) => {
    event.preventDefault();
    // Here you would handle form submission and pass the form values

    try {
      setCreateDashboardLoading(true)
      const response = await apiInstance.put(`reporttool/dashboard/dashboards/da51518f-dbd4-4bb9-ad35-0bbfb20133b2`, {
        dashboardName: dashboardName
      });
      if (response?.data?.dashboardName == dashboardName) {
        closeEditDashboard()
        showAlert({
          id: response?.data?.id,
          title: 'Update Dashboard',
          message: `${response?.data?.dashboardName} Has Been Updated Successfully.`,
          variant: 'success',
          autoClose: 2000
        });
        return
      }

      closeEditDashboard()
      showAlert({
        id: 'error-creating',
        title: 'Update Dashboard Faild',
        variant: 'error',
        autoClose: 2000
      });
    } catch (error) {
    } finally {
      setNewDashboardName("")
      setCreateDashboardLoading(false)
    }





    // close(); // Close the modal after submission
  };

  const handleDeleteDashboard = async () => {
    try {
      setCreateDashboardLoading(true)
      const response = await apiInstance.delete(`reporttool/dashboard/dashboards/delete/${dashboard?.id}`);
      console.log(response?.data);

      if (response?.data?.message) {
        dispatch(getDashbardsList({

          submitCallback: (data: any) => {
            const dash = data && data?.length > 0 && data[0] || null
            if (dash?.id) {
              dispatch(setSelectedDashboard({ dashboard_id: dash?.id }))
              return
            }

            dispatch(setSelectedDashboardSuccess({
              dashboard: null,
              charts: null
            }))
          }
        }))
        closeDelete()
        showAlert({
          id: response?.data?.id,
          title: 'Deleted',
          message: `Dashboard Has Been Deleted Successfully.`,
          variant: 'success',
          autoClose: 2000
        });
        return
      }

      closeDelete()
      showAlert({
        id: 'error-creating',
        title: 'Delete Dashboard Faild',
        variant: 'error',
        autoClose: 2000
      });
    } catch (error) {
      console.log(`Delete Dashboard Faild : ${error}`);
    } finally {
      setCreateDashboardLoading(false)
    }
  }
  const websiteData = [
    { name: 'Google', score: 98 },
    { name: 'Facebook', score: 85 },
    { name: 'Twitter', score: 90 },
    { name: 'LinkedIn', score: 87 },
  ];
  const rows = websiteData.map((site, index) => (
    <tr key={index}>
      <td>{site.name}</td>
      <td>{site.score}</td>
    </tr>
  ));
  const [chartTitle, setChartTitle] = useState("");
  const [dataType, setDataType] = useState("");

  const accessibilityPieChartData = {
    labels: ['Critical Impact', 'High Impact', 'Medium Impact', 'Low Impact'],
    datasets: [
      {
        data: [40, 30, 20, 10], // Values representing the number of issues or percentages
        backgroundColor: ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF'],
        // hoverBackgroundColor: ['#da604e', '#FF5733', '#ffd700a6', '#DAF7A6'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };
  const options_Pie: ChartOptions<'pie'> = {
    // maintainAspectRatio: false,

    // responsive: true,
    plugins: {
      datalabels: {
        display: false,
        // color: '#fff'
      },
      legend: {
        display: false,
        // position: 'top',
        // labels: {
        //   color: '#222'
        // }
      },
      tooltip: {
        bodyColor: '#fff',
        backgroundColor: '#000'
      },

      title: {
        display: true,
        text: 'Accessibility Impact Overview',
        color: '#fff',
        font: {
          size: 24,
          weight: 'bold',
          style: 'normal'
        },
      }
    }
  };

  // start
  let ChartObjectCommonIssues: { labels: Array<string>, datasets: Array<number> } = {
    labels: [],
    datasets: [],
  }
  if (commonIssues) {
    Object.entries(commonIssues).map((elm, index) => {
      if (elm) {
        const label = `${elm[0]}-${wcag_guidelines[elm[0]]}` 
        elm[0] && ChartObjectCommonIssues.labels.push(label)
        elm[1] && ChartObjectCommonIssues.datasets.push(elm[1]?.nbrOfIssues)
      }

      return elm
    })
  }

  let ChartObjectCommonSeccess: { labels: Array<string>, datasets: Array<number> } = {
    labels: [],
    datasets: [],
  }

  if (commonSeccess) {
    Object.entries(commonSeccess).map((elm, index) => {
      if (elm) {
        const label = `${elm[0]}-${wcag_guidelines[elm[0]]}`
        elm[0] && ChartObjectCommonSeccess.labels.push(label)
        elm[1] && ChartObjectCommonSeccess.datasets.push(parseInt(String(elm[1]?.nbrOfIssues)))
      }

      return elm
    })
  }
  const commonAccessibilityIssuesData = {
    labels: ChartObjectCommonSeccess?.labels,
    datasets: [
      {
        label: 'Number of Issues',
        data: ChartObjectCommonSeccess?.datasets, // Example values representing the number of occurrences
        backgroundColor: ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF'],
        // borderColor: ['#FF5733', '#33FF57', '#3357FF', '#ffd700a6', '#FF33A6'],
        borderWidth: 1,

      },
    ],
  };
  const commonAccessibilityWCAGData = {
    labels: ChartObjectCommonIssues?.labels, // Success criteria codes and descriptions
    datasets: [
      {
        label: 'Number of Issues',
        data: ChartObjectCommonIssues.datasets, // Example values representing the number of occurrences
        backgroundColor: ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF', '#ffd700a6'],
        borderWidth: 1,
      },
    ],
  };

  // const commonAccessibilityIssuesData_options = {
  //   scales: {
  //     y: {
  //       beginAtZero: true, // Ensures the y-axis starts at 0
  //     },
  //   },
  //   plugins: {
  //     datalabels: {
  //       display: false,
  //       color: '#fff'
  //     },
  //   },
  // };
  const commonAccessibilityIssuesData_options = {
    responsive: true,
    plugins: {
      datalabels: { display: false },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            let label = "";
            if (context.parsed.y) {
              label = context.parsed.y + "%";
            }
            return label;
          }
        }
      }
    },
    onClick: (event: any, elements: any, chart: any) => {
      // Check if a bar element was clicked
      if (elements.length > 0) {
        const elementIndex = elements[0].index; // Index of the clicked bar
        const label = chart.data.labels[elementIndex]; // Label of the clicked bar
        // Redirect based on the label
        const url = `/insight/dashboard/test.vially.ie/automated-audit?Criteria=${label}`; // Customize URL based on label
        window.open(url, '_blank'); // Opens the link in a new tab
      }
    }
  };



  const ImpactChartData = {
    labels: ['Critical Impact', 'High Impact', 'Medium Impact', 'Low Impact'],
    datasets: [
      {
        data: [40, 30, 20, 10], // Values representing the number of issues or percentages
        backgroundColor: ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF'],
        // hoverBackgroundColor: ['#da604e', '#FF5733', '#ffd700a6', '#DAF7A6'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };





  const handleZoomChange = (size: string) => {
    setZoomLevel(size);
  };
  // Dynamically set the width based on the selected zoom level
  const getSizeStyle = () => {
    switch (zoomLevel) {
      case 'sm':
        return { width: '300px', height: '100%' };
      case 'md':
        return { width: '500px', height: '100%' };
      case 'lg':
        return { width: '100%', height: '100%' };
      default:
        return { width: '100%', height: '100%' }; // Default is 'md'
    }
  };
  const [headerFontSize, setHeaderFontSize] = useState(14);  // Default size is 14
  const [labelFontSize, setLabelFontSize] = useState(12);  // Default size is 12
  const [labelColor, setLabelColor] = useState('#000000');  // Default color is black
  const { showAlert } = useAlert()
  const [createOrEdit, setCreateOrEdit] = useState("Create Dashboard")





  const moveItem = (index: number, direction: 'up' | 'down' | 'left' | 'right') => {
    const newItems = [...items]
    let newIndex: number

    switch (direction) {
      case 'up':
        newIndex = index - 2
        if (newIndex >= 0) {
          [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]]
        }
        break
      case 'down':
        newIndex = index + 2
        if (newIndex < items.length) {
          [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]]
        }
        break
      case 'left':
        if (index % 2 !== 0) {
          [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]]
        }
        break
      case 'right':
        if (index % 2 === 0 && index + 1 < items.length) {
          [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]]
        }
        break
    }

    setItems(newItems)
  }


  const getSCoreColor = (score: number) => {

    if (score > 50) {
      return "#da604e";
    } else if (score >= 30) {
      return "#035e11b0";
    } else {
      return "#a3e6e1"
    }
  }



  const [items, setItems] = useState<GridItem[]>([
    // {
    //   id: 1,
    //   title: 'Accessibility score progress Overview',
    //   content: !CHART_DATA ? (
    //     <Flex align={'center'} direction={'column'}>
    //       <Fragment>
    //         <NoDataGraph aria-hidden="true" />
    //         <Text py={24}>{t('noDataGraphText')}</Text>
    //       </Fragment>
    //     </Flex>
    //   ) : (
    //     <Flex direction={"column"} justify={"space-between"} style={{ flexGrow: 1, width: '100%', height: '100%' }}>
    //       <LineChart w={true} options={CHART_OPTIONS()} data={CHART_DATA} />
    //     </Flex>
    //   ),
    //   table: <table style={{
    //     border: "1px solid #ddd", // Lighter border color for a softer look
    //     borderCollapse: "collapse",
    //     width: '100%',
    //     boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //     backgroundColor: "#f9f9f9" // Light background for better readability
    //   }}>
    //     <thead>
    //       <tr style={{
    //         backgroundColor: "#f2f2f2", // Slightly darker background for header
    //         borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //       }}>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px", // More padding for a spacious look
    //           textAlign: "left", // Align text to the left for default
    //           fontWeight: "bold" // Bold text for headers
    //         }}>Label</th>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px",
    //           textAlign: "left"
    //         }}>Date</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {CHART_DATA.datasets.map((dataset, index) => (
    //         <tr style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }} key={index} className={dataset.label.replace(/\s+/g, "-")}>
    //           <td style={{
    //             border: "1px solid #ddd",
    //             padding: "10px" // Consistent padding
    //           }}>
    //             <Flex align={"center"} gap={"sm"} >

    //               {/* { 
    //                 dataset.label == 'CompliantScore' ? '#2A2B4B' : dataset.label == 'Target' ? '#035e11b0' : dataset?.label == 'Critical' ? '#da604e' : ''
    //               } */}
    //               <span style={{ width: '20px', height: '20px', background: '', borderRadius: '1rem' }}></span>
    //               {dataset.label}
    //             </Flex>
    //           </td>
    //           <td style={{
    //             padding: "10px",
    //             border: "1px solid #ddd"
    //           }}>
    //             {CHART_DATA?.labels && CHART_DATA?.labels[index] ? CHART_DATA?.labels[index] : 'N/A'}</td>
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>
    // },
    {
      id: 4, title: 'Company-Wide Vially Score Overview',
      popover: 'The average Vially Score across all company websites, calculated from the most recent audit of each site.',
      content:
        <>
          <div style={{ width: '100%' }}>
            <SemiCircleProgress
              percentage={complianceScore ? parseInt(String((complianceScore))) : 0}
              showPercentValue={true}
              diameter={300}
              strokeWidth={20}
            />
            <p style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700' }}>Vially Score : {complianceScore ? parseInt(String(complianceScore)) : 0}%</p>
            <p style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700' }} >
              <Link target='_blank' to="/faq?tab=vially-score" >What Is Vially Score</Link>
            </p>
          </div>
          <Space h={"sm"} />
        </>,

      table: (
        <table style={{
          border: "1px solid #ddd", // Lighter border color for a softer look
          borderCollapse: "collapse",
          width: '100%',
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
          backgroundColor: "#f9f9f9" // Light background for better readability
        }}>
          <thead>
            <tr style={{
              backgroundColor: "#f2f2f2", // Slightly darker background for header
              borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
            }}>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px", // More padding for a spacious look
                textAlign: "left", // Align text to the left for default
                fontWeight: "bold" // Bold text for headers
              }}>Label</th>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "left"
              }}>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#035e11b0', borderRadius: '1rem' }}></span>
                  Vially Score
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{complianceScore ? parseInt(String(complianceScore)) : 0}%</td>
            </tr>
          </tbody>
        </table>
      )
    },
    {
      id: 2, title: 'Average Criteria Results per Website',

      popover: 'Shows the average of criteria passed, partially passed, and failed across all company websites based on their most recent audit.',

      content:
        <>
          <ComplianceScoreCard
            colors={["#035e11b0", "#da604e", "#2A2B4B   "]}
            complianceScore={parseInt(String(complianceScore))}
            complianceLevel={complianceLevel}
            description={description}
            number_passed={parseInt(String(criteriaPassed)) ?? 0}
            cant_tested={parseInt(String(criteriaNotTested)) ?? 0}
            number_that_fails={parseInt(String(criteriaFailed)) ?? 0}
          />
        </>,
      table: <table style={{
        border: "1px solid #ddd", // Lighter border color for a softer look
        borderCollapse: "collapse",
        width: '100%',
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
        backgroundColor: "#f9f9f9" // Light background for better readability
      }}>
        <thead>
          <tr style={{
            backgroundColor: "#f2f2f2", // Slightly darker background for header
            borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
          }}>
            <th style={{
              border: "1px solid #ddd",
              padding: "10px", // More padding for a spacious look
              textAlign: "left", // Align text to the left for default
              fontWeight: "bold" // Bold text for headers
            }}>Label</th>
            <th style={{
              border: "1px solid #ddd",
              padding: "10px",
              textAlign: "left"
            }}>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{
            borderBottom: "1px solid #ddd" // Consistent border styling
          }}>
            <td style={{
              border: "1px solid #ddd",
              padding: "10px" // Consistent padding
            }}>
              <Flex align={"center"} gap={"sm"} >
                <span style={{ width: '20px', height: '20px', background: '#035e11b0', borderRadius: '1rem' }}></span>
                Criteria Passed
              </Flex>
            </td>
            <td style={{
              padding: "10px",
              border: "1px solid #ddd"
            }}>{parseInt(String(criteriaPassed))}</td>
          </tr>
          <tr style={{
            borderBottom: "1px solid #ddd" // Consistent border styling
          }}>
            <td style={{
              border: "1px solid #ddd",
              padding: "10px" // Consistent padding
            }}>
              <Flex align={"center"} gap={"sm"} >
                <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                Criteria Not Tested
              </Flex>
            </td>
            <td style={{
              padding: "10px",
              border: "1px solid #ddd"
            }}>{parseInt(String(criteriaNotTested))}</td>
          </tr>
          <tr style={{
            borderBottom: "1px solid #ddd" // Consistent border styling
          }}>
            <td style={{
              border: "1px solid #ddd",
              padding: "10px" // Consistent padding
            }}>
              <Flex align={"center"} gap={"sm"} >
                <span style={{ width: '20px', height: '20px', background: '#da604e', borderRadius: '1rem' }}></span>
                Criteria Failed
              </Flex></td>
            <td style={{
              padding: "10px",
              border: "1px solid #ddd"
            }}>{parseInt(String(criteriaFailed))}</td>
          </tr>
        </tbody>
      </table>
    },
    {
      id: 3, title: 'Average Issue Count by Priority Level',
      popover: 'Displays the average number of accessibility issues across all company websites, grouped by Priority (Critical, High, Medium, Low), based on their most recent audit.',
      content: (
        <PieChart
          warning={Math.trunc(issuesCountByPriority?.warning) ?? 0}
          medium={Math.trunc(issuesCountByPriority?.medium) ?? 0}
          low={Math.trunc(issuesCountByPriority?.low) ?? 0}
          high={Math.trunc(issuesCountByPriority?.high) ?? 0}
          critical={Math.trunc(issuesCountByPriority?.critical) ?? 0}
        />
      ),
      table: (
        <table style={{
          border: "1px solid #ddd", // Lighter border color for a softer look
          borderCollapse: "collapse",
          width: '100%',
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
          backgroundColor: "#f9f9f9" // Light background for better readability
        }}>
          <thead>
            <tr style={{
              backgroundColor: "#f2f2f2", // Slightly darker background for header
              borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
            }}>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px", // More padding for a spacious look
                textAlign: "left", // Align text to the left for default
                fontWeight: "bold" // Bold text for headers
              }}>Label</th>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "left"
              }}>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#DA604E', borderRadius: '1rem' }}></span>
                  Warning
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{issuesCountByPriority?.warning ?? 0}</td>
            </tr>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#A3E6E1', borderRadius: '1rem' }}></span>
                  Low
                </Flex></td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{Math.trunc(issuesCountByPriority?.low) ?? 0}</td>
            </tr>

            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                  Medium
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{Math.trunc(issuesCountByPriority?.medium) ?? 0}</td>
            </tr>


            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#FF8C00', borderRadius: '1rem' }}></span>
                  High
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{Math.trunc(issuesCountByPriority?.high) ?? 0}</td>
            </tr>


            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#B22222', borderRadius: '1rem' }}></span>
                  Critical
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{Math.trunc(issuesCountByPriority?.critical) ?? 0}</td>
            </tr>

          </tbody>
        </table>
      )
    },
    {
      id: 5
      , title: 'Total Issue Status Summary',
      popover: 'Summarizes the total number of new, open, and closed accessibility issues across all company websites, based on their most recent audit.',
      content:

        <>
          <div style={{ width: '100%', height: '300px', justifyContent: 'center' }}>
            <UsageChart isPercent={false} data={[
              { label: 'Total Issues', value: parseInt(String(numberOfIssues)) },
              { label: 'Closed Issues', value: parseInt(String(closedIssues)) },
              { label: 'New Issues', value: parseInt(String(newsIssues)) },
              { label: 'Open Issues', value: parseInt(String(openIssues)) },
            ]} noShadow />
          </div>
          <Space h={"sm"} />

        </>,
      table: (
        <table style={{
          border: "1px solid #ddd", // Lighter border color for a softer look
          borderCollapse: "collapse",
          width: '100%',
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
          backgroundColor: "#f9f9f9" // Light background for better readability
        }}>
          <thead>
            <tr style={{
              backgroundColor: "#f2f2f2", // Slightly darker background for header
              borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
            }}>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px", // More padding for a spacious look
                textAlign: "left", // Align text to the left for default
                fontWeight: "bold" // Bold text for headers
              }}>Label</th>
              <th style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "left"
              }}>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                  Closed Issues
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{parseInt(String(closedIssues))}</td>
            </tr>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                  Total Issues
                </Flex>
              </td>

              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{parseInt(String(numberOfIssues))}</td>
            </tr>


            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                  New Issues
                </Flex></td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{parseInt(String(newsIssues))}</td>
            </tr>
            <tr style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
              <td style={{
                border: "1px solid #ddd",
                padding: "10px" // Consistent padding
              }}>
                <Flex align={"center"} gap={"sm"} >
                  <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
                  Open Issues
                </Flex>
              </td>
              <td style={{
                padding: "10px",
                border: "1px solid #ddd"
              }}>{parseInt(String(openIssues))}</td>
            </tr>


          </tbody>
        </table>)
    },
    // {
    //   id: 6,
    //   // popover : 'In Simple Math, the score is calculated as (Total Passed Criteria / Total Criteria) * 100 - Penalty, but if the score drops too low, it won’t go below a minimum threshold (e.g., 10%).',
    //   title: 'Accessibility Impact Overview', content:
    //     <>
    //       {/* <Flex justify={"start"} align={"center"} w={"100%"}>
    //         <Select
    //           className={`${styles.dropDown}`}
    //           label="View"
    //           data={[
    //             { value: 'open', label: 'Open' },
    //             { value: 'closed', label: 'Closed' },
    //             { value: 'progress', label: 'Progress' },
    //           ]}
    //           value={'open'}
    //           onChange={(e) => e && setPermission(e)}
    //         />
    //       </Flex> */}
    //       <div className={'imapcChart'} style={{ width: 'auto', height: '300px', margin: '0 auto', textAlign: 'center' }}>
    //         <Pie data={accessibilityPieChartData} options={options_Pie} />
    //       </div>
    //       <p style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700', margin: '0 auto' }} > <Link to="/faq" >What Is Accessibility Impact Overview</Link> </p>
    //       <Space h={"sm"} />

    //     </>,
    //   table: (<table style={{
    //     border: "1px solid #ddd", // Lighter border color for a softer look
    //     borderCollapse: "collapse",
    //     width: '100%',
    //     boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //     backgroundColor: "#f9f9f9" // Light background for better readability
    //   }}>
    //     <thead>
    //       <tr style={{
    //         backgroundColor: "#f2f2f2", // Slightly darker background for header
    //         borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //       }}>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px", // More padding for a spacious look
    //           textAlign: "left", // Align text to the left for default
    //           fontWeight: "bold" // Bold text for headers
    //         }}>Label</th>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px",
    //           textAlign: "left"
    //         }}>Value</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr style={{
    //         borderBottom: "1px solid #ddd" // Consistent border styling
    //       }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"} >
    //             <span style={{ width: '20px', height: '20px', background: '#035e11b0', borderRadius: '1rem' }}></span>
    //             Critical Impact
    //           </Flex>
    //         </td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>40</td>
    //       </tr>
    //       <tr style={{
    //         borderBottom: "1px solid #ddd" // Consistent border styling
    //       }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"} >
    //             <span style={{ width: '20px', height: '20px', background: '#da604e', borderRadius: '1rem' }}></span>
    //             High Impact
    //           </Flex>
    //         </td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>40</td>
    //       </tr>
    //       <tr style={{
    //         borderBottom: "1px solid #ddd" // Consistent border styling
    //       }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"} >
    //             <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
    //             Medium Impact
    //           </Flex></td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>90</td>
    //       </tr>
    //       <tr style={{
    //         borderBottom: "1px solid #ddd" // Consistent border styling
    //       }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"} >
    //             <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
    //             Low Impact
    //           </Flex></td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>90</td>
    //       </tr>
    //     </tbody>
    //   </table>)
    // },
    // {
    //   id: 7, title: 'Most Common Accessibility Issues Overview', content:
    //     <>
    //       <div style={{ width: '100%' }}>
    //         <Bar data={commonAccessibilityIssuesData} options={commonAccessibilityIssuesData_options} />
    //       </div>
    //       <Space h={"sm"} />

    //     </>,
    //   table: (
    //     <table style={{
    //       border: "1px solid #ddd", // Lighter border color for a softer look
    //       borderCollapse: "collapse",
    //       width: '100%',
    //       boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //       backgroundColor: "#f9f9f9" // Light background for better readability
    //     }}>
    //       <thead>
    //         <tr style={{
    //           backgroundColor: "#f2f2f2", // Slightly darker background for header
    //           borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //         }}>
    //           <th style={{
    //             border: "1px solid #ddd",
    //             padding: "10px", // More padding for a spacious look
    //             textAlign: "left", // Align text to the left for default
    //             fontWeight: "bold" // Bold text for headers
    //           }}>Label</th>
    //           <th style={{
    //             border: "1px solid #ddd",
    //             padding: "10px",
    //             textAlign: "left"
    //           }}>Value</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         <tr style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //           <td style={{
    //             border: "1px solid #ddd",
    //             padding: "10px" // Consistent padding
    //           }}>
    //             <Flex align={"center"} gap={"sm"}>
    //               <span style={{ width: '20px', height: '20px', background: '#A3E6E1', borderRadius: '1rem' }}></span>
    //               <Link className={styles.link} to={"https://vially.io/wcag-1-1-1#main-content"}>1.1.1 Non-text Content</Link>
    //             </Flex>
    //           </td>
    //           <td style={{
    //             padding: "10px",
    //             border: "1px solid #ddd"
    //           }}>40</td>
    //         </tr>
    //         <tr style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //           <td style={{
    //             border: "1px solid #ddd",
    //             padding: "10px" // Consistent padding
    //           }}>
    //             <Flex align={"center"} gap={"sm"}>
    //               <span style={{ width: '20px', height: '20px', background: '#DA604E', borderRadius: '1rem' }}></span>
    //               <Link className={styles.link} to={"https://vially.io/wcag-1-3-1#main-content"}> 1.3.1 Info and Relationships</Link>
    //             </Flex>
    //           </td>
    //           <td style={{
    //             padding: "10px",
    //             border: "1px solid #ddd"
    //           }}>40</td>
    //         </tr>
    //         <tr style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //           <td style={{
    //             border: "1px solid #ddd",
    //             padding: "10px" // Consistent padding
    //           }}>
    //             <Flex align={"center"} gap={"sm"}>
    //               <span style={{ width: '20px', height: '20px', background: '#2A2B4B', borderRadius: '1rem' }}></span>
    //               <Link className={styles.link} to={"https://vially.io/wcag-1-3-1#main-content"}> 1.3.3 Sensory Characteristics</Link>
    //             </Flex>
    //           </td>
    //           <td style={{
    //             padding: "10px",
    //             border: "1px solid #ddd"
    //           }}>90</td>
    //         </tr>
    //         <tr style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //           <td style={{
    //             border: "1px solid #ddd",
    //             padding: "10px" // Consistent padding
    //           }}>
    //             <Flex align={"center"} gap={"sm"}>
    //               <span style={{ width: '20px', height: '20px', background: '#5B5EFF', borderRadius: '1rem' }}></span>
    //               <Link className={styles.link} to={"https://vially.io/wcag-1-4-3#main-content"}> 1.4.3 Contrast (Minimum)</Link>
    //             </Flex>
    //           </td>
    //           <td style={{
    //             padding: "10px",
    //             border: "1px solid #ddd"
    //           }}>90</td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   )

    // },
    {
      id: 8,
      title: 'Top WCAG Violations Across Company Websites',
      popover: 'Highlights the most frequently violated Web Content Accessibility Guidelines (WCAG) criteria across all company websites based on their most recent audit.',
      content:
        <>
          <div style={{ width: '100%' }}>
            <Bar data={commonAccessibilityWCAGData} options={commonAccessibilityIssuesData_options} />
          </div>
          <Space h={"lg"} />

        </>,
      table: (<table style={{
        border: "1px solid #ddd", // Lighter border color for a softer look
        borderCollapse: "collapse",
        width: '100%',
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
        backgroundColor: "#f9f9f9" // Light background for better readability
      }}>
        <thead>
          <tr style={{
            backgroundColor: "#f2f2f2", // Slightly darker background for header
            borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
          }}>
            <th style={{
              border: "1px solid #ddd",
              padding: "10px", // More padding for a spacious look
              textAlign: "left", // Align text to the left for default
              fontWeight: "bold" // Bold text for headers
            }}>Label</th>
            <th style={{
              border: "1px solid #ddd",
              padding: "10px",
              textAlign: "left"
            }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {
            commonAccessibilityWCAGData?.labels?.map((label, index) => {
              const c = ["#a3e6e1", "#da604e", "#2a2b4b", "#5b5eff", "#ffe559"];
              const color = c[index % c.length]; // wrap color index if index is too large

              return (
                <tr
                  key={label}
                  style={{ borderBottom: "1px solid #ddd" }}
                >
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    <Flex align={"center"} gap={"sm"}>
                      <span
                        style={{
                          width: '20px',
                          height: '20px',
                          background: color,
                          borderRadius: '1rem',
                        }}
                      ></span>
                      <a className={styles.link} href={`https://vially.io/services/wcag-${label.replaceAll(".", "-")}#main-content`} target='_blank'>
                        {label}
                      </a>
                    </Flex>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {parseInt(String(commonAccessibilityWCAGData?.datasets[0]?.data[index]))}%
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>)
    },
    // {
    //   id: 9,
    //   title: 'Compliance Score Overview',
    //   content:


    //     <>
    //       <div style={{ width: '90%', margin: '0 auto' }}>
    //         <GaugeChart
    //           style={{ width: '100%' }}
    //           id="gauge-chart2"
    //           percent={complianceScore / 100}
    //           textColor="#000000"
    //           needleColor="#464A4F"
    //           colors={['#A3E6E1', '#DA604E']}
    //         />
    //       </div>
    //       <div style={{ width: '100%', textAlign: 'center' }}>
    //         <Link style={{ textAlign: "center" }} to="/faq" >What is Compliance Score Overview</Link>
    //       </div>

    //     </>,
    //   table: (<table style={{
    //     border: "1px solid #ddd", // Lighter border color for a softer look
    //     borderCollapse: "collapse",
    //     width: '100%',
    //     boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //     backgroundColor: "#f9f9f9" // Light background for better readability
    //   }}>
    //     <thead>
    //       <tr style={{
    //         backgroundColor: "#f2f2f2", // Slightly darker background for header
    //         borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //       }}>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px", // More padding for a spacious look
    //           textAlign: "left", // Align text to the left for default
    //           fontWeight: "bold" // Bold text for headers
    //         }}>Label</th>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px",
    //           textAlign: "left"
    //         }}>Value</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr
    //         style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"}>
    //             <span style={{ width: '20px', height: '20px', background: getSCoreColor(complianceScore), borderRadius: '1rem' }}></span>
    //             <p className={styles.link}>Compliance Score</p>
    //           </Flex>
    //         </td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>{complianceScore ? parseInt(String(complianceScore)) + '%' : 0}</td>
    //       </tr>
    //     </tbody>
    //   </table>)

    // },
    // {
    //   id: 10,
    //   title: 'Accessibility Score Overview',
    //   content:
    //     <>
    //       <div style={{ width: '90%', margin: '0 auto' }}>
    //         <GaugeChart
    //           id="gauge-chart2"
    //           style={{ width: '100%' }}
    //           // nrOfLevels={20}  // Number of segments in the gauge
    //           percent={ialabsScore / 100}   // The value to display (75%)
    //           textColor="#000000"  // Text color for the value displayed
    //           needleColor="#464A4F"  // Color of the needle
    //           colors={['#A3E6E1', '#DA604E']}  // Gradient from red to yellow for the chart
    //         />
    //       </div>
    //       <div style={{ width: '100%', textAlign: 'center' }}>
    //         <Link to="/faq" style={{ textAlign: "center" }} >What is Accessibility Score Overview</Link>
    //       </div>

    //     </>,
    //   table: (<table style={{
    //     border: "1px solid #ddd", // Lighter border color for a softer look
    //     borderCollapse: "collapse",
    //     width: '100%',
    //     boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //     backgroundColor: "#f9f9f9" // Light background for better readability
    //   }}>
    //     <thead>
    //       <tr style={{
    //         backgroundColor: "#f2f2f2", // Slightly darker background for header
    //         borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //       }}>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px", // More padding for a spacious look
    //           textAlign: "left", // Align text to the left for default
    //           fontWeight: "bold" // Bold text for headers
    //         }}>Label</th>
    //         <th style={{
    //           border: "1px solid #ddd",
    //           padding: "10px",
    //           textAlign: "left"
    //         }}>Value</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       <tr
    //         style={{
    //           borderBottom: "1px solid #ddd" // Consistent border styling
    //         }}>
    //         <td style={{
    //           border: "1px solid #ddd",
    //           padding: "10px" // Consistent padding
    //         }}>
    //           <Flex align={"center"} gap={"sm"}>
    //             <span style={{ width: '20px', height: '20px', background: getSCoreColor(ialabsScore), borderRadius: '1rem' }}></span>
    //             <p className={styles.link}>Accessibility Score</p>
    //           </Flex>
    //         </td>
    //         <td style={{
    //           padding: "10px",
    //           border: "1px solid #ddd"
    //         }}>{parseInt(String(ialabsScore))}%</td>
    //       </tr>
    //     </tbody>
    //   </table>)

    // },
    {
      id: 11, title: 'Highest Scoring Website (Latest Audit)',
      popover: 'Lists websites with lowest Vially Scores from its most recent audit, with scores ranging from 0 - 50. This indicates a high level of accessibility risk requiring immediate attention.',
      content: <DashboardTableRanking webSitesData={webSitesData} />
    },

    {
      id: 12, title: 'Websites with High Accessibility Risks',
      popover: 'Lists websites with the highest Vially Score from its most recent audit, with scores ranging from 50-100%. This representsthe websites with the best accessibility performance in the company.', content: <DashboardTableRankingRisk webSitesData={webSitesData} />
    },
    // {
    //   id: 13, title: 'Total Issues Found by Automated Scan Over Time', content: <ScanProgressChart issuesCountOverTime={issuesCountOverTime} />, table: (
    //     <div style={{ maxWidth: '95%', overflowX: 'scroll' }}>
    //       <table style={{
    //         border: "1px solid #ddd", // Lighter border color for a softer look
    //         borderCollapse: "collapse",
    //         width: '100%',
    //         boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
    //         backgroundColor: "#f9f9f9" // Light background for better readability
    //       }}>
    //         <thead>
    //           <tr style={{
    //             backgroundColor: "#f2f2f2", // Slightly darker background for header
    //             borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
    //           }}>
    //             <th style={{
    //               border: "1px solid #ddd",
    //               padding: "10px", // More padding for a spacious look
    //               textAlign: "left", // Align text to the left for default
    //               fontWeight: "bold" // Bold text for headers
    //             }}>
    //               Scan Date</th>
    //             <th style={{
    //               border: "1px solid #ddd",
    //               padding: "10px", // More padding for a spacious look
    //               textAlign: "left", // Align text to the left for default
    //               fontWeight: "bold" // Bold text for headers
    //             }}>
    //               <Flex align={"center"} gap={"sm"}>
    //                 <span style={{ width: '20px', height: '20px', background: '#2a2b4b', borderRadius: '1rem' }}></span>
    //                 <p className={styles.link}>Total Issues</p>
    //               </Flex>
    //             </th>
    //             <th style={{
    //               border: "1px solid #ddd",
    //               padding: "10px", // More padding for a spacious look
    //               textAlign: "left", // Align text to the left for default
    //               fontWeight: "bold" // Bold text for headers
    //             }}>

    //               <Flex align={"center"} gap={"sm"}>
    //                 <span style={{ width: '20px', height: '20px', background: '#a3e6e1', borderRadius: '1rem' }}></span>
    //                 <p className={styles.link}>Open Issues</p>
    //               </Flex>
    //             </th>
    //             <th style={{
    //               border: "1px solid #ddd",
    //               padding: "10px", // More padding for a spacious look
    //               textAlign: "left", // Align text to the left for default
    //               fontWeight: "bold" // Bold text for headers
    //             }}>
    //               <Flex align={"center"} gap={"sm"}>
    //                 <span style={{ width: '20px', height: '20px', background: '#035e11b0', borderRadius: '1rem' }}></span>
    //                 <p className={styles.link}>Closed Issues</p>
    //               </Flex>
    //             </th>
    //             <th style={{
    //               border: "1px solid #ddd",
    //               padding: "10px", // More padding for a spacious look
    //               textAlign: "left", // Align text to the left for default
    //               fontWeight: "bold" // Bold text for headers
    //             }}>
    //               <Flex align={"center"} gap={"sm"}>
    //                 <span style={{ width: '20px', height: '20px', background: '#da604e', borderRadius: '1rem' }}></span>
    //                 <p className={styles.link}> New Issues</p>
    //               </Flex>
    //             </th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {issuesCountOverTime?.actual?.length > 0 ? issuesCountOverTime?.actual.map((scan, index) => (
    //             <tr
    //               key={scan?.date + index}
    //               style={{
    //                 borderBottom: "1px solid #ddd" // Consistent border styling
    //               }}>
    //               <td style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px" // Consistent padding
    //               }}>{scan.date}</td>
    //               <td style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px" // Consistent padding
    //               }}>{scan.totalIssues}</td>
    //               <td style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px" // Consistent padding
    //               }}>{scan.openIssues}</td>
    //               <td style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px" // Consistent padding
    //               }}>{scan.closedIssues}</td>
    //               <td style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px" // Consistent padding
    //               }}>{scan.openIssues}</td>
    //             </tr>
    //           )) :

    //             <tr>
    //               <td colSpan={5} style={{
    //                 border: "1px solid #ddd",
    //                 padding: "10px",
    //                 textAlign: "center"
    //               }}>No data available</td>
    //             </tr>

    //           }


    //         </tbody>
    //       </table> </div>)
    // }
  ])

  const [selectedLabel, setSelectedLabel] = useState<string>('');
  const [selectedSites, setSelectedSites] = useState<string[]>([]);
  const [selectedAccessibilityStatement, setSelectedAccessibilityStatement] = useState<string>('');

  const labelsList = ['Marketing', 'Sales', 'Finance', 'Support'];

  const accessibilityStatements = ['doc 1', 'doc 2', 'doc 3', 'doc 4'];
  const websiteList = [
    { value: 'website1', label: 'Website 1' },
    { value: 'website2', label: 'Website 2' },
    { value: 'website3', label: 'Website 3' },
  ];


  // const allowedDataSources = [
  //   // "accessibility_score_progress",
  //   "vially_accessibility_overview",
  //   "issues_by_priority",
  //   "vially_score",
  //   "issues_count",
  //   // "accessibility_impact",
  //   // "most_common_accessibility_issues",
  //   "most_common_success_criteria",
  //   // "compliance_score",
  //   // "accessibility_score",
  //   "best_ranking_website",
  //   "high_risk_websites",
  //   // "total_issues_over_time"
  // ];
  const allowedDataSources = [
    { label: "Average Criteria Results per Website", value: "vially_accessibility_overview" },
    { label: "Average Issue Count by Severity Level", value: "issues_by_priority" },
    { label: "Company-Wide Vially Score Overview", value: "vially_score" },
    { label: "Total Issue Status Summary", value: "issues_count" },
    { label: "Top WCAG Violations Across Company Websites", value: "most_common_success_criteria" },
    { label: "Highest Scoring Website (Latest Audit)", value: "best_ranking_website" },
    { label: "Websites with High Accessibility Risks", value: "high_risk_websites" }
  ];
  const [companiesList, setCompaniesList] = useState([])
  const [selectedCompanyDropdown, setSelectedCompanyDropdown] = useState(setSelectedCompany?.company_id ?? company_id)
  useEffect(() => {
    // if ( dashboard?.id ) {
    setShowDefault(false)
    setDashboardSelec(dashboard?.id ?? 'default')
    // setSelectedCompanyDropdown(company_id)
    dispatch(setSelectedDashboard({ dashboard_id: dashboard?.id }))
    // }
  }, [])




  useEffect(() => {
    if (!getOwnCompaniesdata) {
      dispatch(getOwnCompanies());
    }

    if (getOwnCompaniesdata) {
      const data = getOwnCompaniesdata
        ?.filter((company: any) => company?.is_deleted == 'false')
        .map((company: any) => ({
          label: company.company_name,
          value: company.id,
        }));
      console.log(data);

      // data?.unshift({ label: company_name, value: company_id }) // add current tantent company
      setCompaniesList(data)
    }
  }, [getOwnCompaniesdata])
  return (
    <div id='export-content' className={styles['site-list']}>
      <div className={styles.container_bg}>
        <Title order={2} id={'mainContent'} color="#2A2B4B" className={classNames(styles['visually-hidden'])}>
          Dashboard Page
        </Title>
        <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>

          <Flex align={"center"} gap={"sm"}>
            <Title order={2} id={'mainContent'} color="#2A2B4B">
              Dashboard Page
            </Title>
          </Flex>
          <Flex gap={"sm"} p={"md"} wrap={"wrap"}>

            {!showDefault && dashboard?.id &&

              <Button
                color='gray-light'
                className={classNames(styles['link-btn'])}
                id={'addSiteButton'}
                // disabled={!hasPermission}
                onClick={openCreateChart}
              >
                <Flex gap={'5px'}>
                  Add Chart
                </Flex>
              </Button>

            }

            <Button
              color='gray-light'
              className={classNames(styles['link-btn'])}
              id={'addSiteButton'}
              onClick={() => {
                setCreateOrEdit("Create Dashboard");
                open();
              }}
            // disabled={!hasPermission}
            >
              <Flex gap={'5px'}>
                Add Dashboard
              </Flex>
            </Button>
            {/* <Button
              color='gray-light'
              className={classNames(styles['link-btn'])}
              id={'addSiteButton'}
              // disabled={!hasPermission}
              onClick={openDelete}
            >
              <Flex gap={'5px'}>
                Delete Dashboard
              </Flex>
            </Button> */}

            {
              !showDefault && dashboard?.id && <Button
                color='gray-light'
                className={classNames(styles['link-btn'])}
                id={'addSiteButton'}
                // disabled={!hasPermission}
                onClick={() => {
                  SetNewEditedNameDashboard(dashboard?.dashboardName)
                  openEditDashoard()
                }}
              >
                <Flex gap={'5px'}>
                  Configure Dashboard
                </Flex>
              </Button>
            }
            {
              !showDefault && dashboard?.id && <Button
                color='gray-light'
                className={classNames(styles['link-btn'])}
                id={'deleteButton'}
                // disabled={!hasPermission}
                onClick={() => {
                  openDelete()
                }}
              >
                <Flex gap={'5px'}>
                  Delete Dashboard
                </Flex>
              </Button>
            }

            {/* <ExportButton /> */}
          </Flex>
        </Flex>
        <Divider />
        <Space h={"md"} />
        <Flex align={"center"} gap={"sm"}>
          <Select
            loading={dashboardsListLoading}
            label='Choose a Company'
            className={styles.dropDown}
            variant="secondary"
            withIcon
            aria-label={`${c('combobox')}`}
            value={selectedCompanyDropdown}
            data={companiesList ?? []}
            onChange={async (e) => {
              if (e == selectedCompanyDropdown) {
                return
              }
              if (!e) {
                return
              }
              setSelectedCompanyDropdown(e ?? "")
              dispatch(setSelectedCompanyofDashborad({
                company_id: e ?? "",
              }))
            }}
          />
          <Select
            disabled={!selectedCompanyDropdown}
            loading={dashboardsListLoading}
            label='Choose a Dashboard'
            className={styles.dropDown}
            variant="secondary"
            withIcon
            aria-label={`${c('combobox')}`}
            value={showDefault ? 'default' : !dashboardsListLoading && dashboard?.id}
            data={!dashboardsListLoading ? [{ label: 'Default', value: 'default' }, ...dashboardsList.map((item: dashboardType) => ({ label: item?.dashboardName, value: item?.id }))] : []}
            onChange={async (e) => {
              // if ( e == dashboardSelec ) {
              //   return
              // }
              if (e && e != 'default') {
                setShowDefault(false)
                dispatch(setSelectedDashboard({ dashboard_id: e }))
                setDashboardSelec(e)
                return
              } else if (e == 'default') {
                setShowDefault(true)
                // dispatch(setSelectedDashboard({ dashboard_id: 'default' }))
                setDashboardSelec('default')
              }
            }}
          />
        </Flex>
      </div>

      <>
        {showDefault ? <div className={styles.gridColums}>
          {items.map((item, index) => (
            <div key={item.id} className={styles.child} >
              <CardComponent
                //   icon={
                //    <Tooltip label="Learn More">
                //       <Link to={'/faq'} target='_blank' aria-label='navigate to frequently asked question to learn more about this chart'> <QuestionCircle aria-hidden='true' /> </Link>
                //    </Tooltip>
                // }
                title={item.title}
                popover={item?.popover}
              // icon={
              //   <Popover
              //     trapFocus={true}
              //     target={
              //       <ActionIcon title='More Options'>
              //         <MoreVertical color="#000000" />
              //       </ActionIcon>
              //     }
              // dropdownTarget={
              //   <Flex justify={"start"} align={"start"} gap={"sm"} direction={"column"} className={classNames(styles['popover-container'])}>
              //     <UnstyledButton className={styles['delete-btn']}>
              //       Delete Chart
              //       <Trash2 color="#da604e" />
              //     </UnstyledButton>
              //     <UnstyledButton onClick={() => { openEdit() }} className={styles['delete-btn']}>
              //       Edit Chart
              //       <Edit />
              //     </UnstyledButton>
              //     <UnstyledButton onClick={() => moveItem(index, 'left')}
              //       disabled={index % 2 === 0} className={styles['delete-btn']}>
              //       Left
              //       <ArrowLeft />
              //     </UnstyledButton>
              //     <UnstyledButton onClick={() => moveItem(index, 'up')}
              //       disabled={index < 2} className={styles['delete-btn']}>
              //       Up
              //       <ArrowUp />
              //     </UnstyledButton>
              //     <UnstyledButton onClick={() => moveItem(index, 'right')}
              //       disabled={index % 2 !== 0 || index === items.length - 1} className={styles['delete-btn']}>
              //       Right
              //       <ArrowRight />
              //     </UnstyledButton>
              //     <UnstyledButton onClick={() => moveItem(index, 'down')}
              //       disabled={index >= items.length - 2} className={styles['delete-btn']}>
              //       Down
              //       <ArrowDown />
              //     </UnstyledButton>

              //   </Flex>
              // }

              //     ></Popover>
              // }
              >

                <div style={{ width: '100%', height: item?.table ? '350px' : 'auto', margin: '0 auto' }}>
                  {item.content}
                </div>
                <Space h={"lg"} />
                {item?.table}
                <Space h={"lg"} />
              </CardComponent>
            </div>
          ))}
        </div> :
          <>
            <DisplayChartsByDashboard contentData={
              {
                accessibilityScoreProgress,
                complianceScore,
                complianceLevel,
                description,
                criteriaPassed,
                criteriaNotTested,
                criteriaFailed,
                issuesCountByPriority,
                numberOfIssues,
                closedIssues,
                newsIssues,
                openIssues,
                commonIssues,
                commonSeccess,
                webSitesData,
                issuesCountOverTime,
                ialabsScore
              }
            } />
            <Space h={"md"} />
          </>}

      </>
      {/* } */}
      {/* {dashboardSelec == "Example1" && <SingleDashboardView />} */}

      {/* create dashboard */}
      <Modal opened={opened} close={close} zIndex={1000} withCloseButton={false} size={450} padding={0}>
        <Flex align={'center'} justify={'center'} direction={"column"} p={28}>
          <Title order={3}>{createOrEdit}</Title>
        </Flex>
        <form onSubmit={handleCreateDashboard}>
          <Flex direction="column" gap="md" p={28}>
            <TextInput
              label="Dashboard Name"
              type="text"
              value={dashboardName}
              placeholder='Enter a Dashboard Name'
              onChange={(event) => setNewDashboardName(event.currentTarget.value)}
            />
            <Space h="md" />
            <Button disabled={!dashboardName || createDashboardLoading} type="submit" color='dark-green' fullWidth loading={createDashboardLoading}>Create</Button>
          </Flex>
        </form>
      </Modal>
      {/* Create Dashboard */}

      {/* edit dashboard */}
      <Modal opened={openedEditDashboard} close={closeEditDashboard} zIndex={1000} withCloseButton={false} size={450} padding={0}>
        <Flex align={'center'} justify={'center'} direction={"column"} p={28}>
          <Title order={3}>Edit Dashboard</Title>
        </Flex>
        <form onSubmit={handleEditDashboard}>
          <Flex direction="column" gap="md" p={28}>
            <TextInput
              label="Dashboard Name"
              type="text"
              value={newEditedNameDashboard}
              placeholder='Enter a Dashboard Name'
              onChange={(event) => SetNewEditedNameDashboard(event.currentTarget.value)}
            />
            <Space h="md" />
            <Button type="submit" color='dark-green' fullWidth loading={createDashboardLoading}>Create</Button>
          </Flex>
        </form>
      </Modal>
      {/* edit Dashboard */}




      {/* Create chart */}
      <Modal close={closeCreateChart} opened={openedCreatChart} zIndex={1000} withCloseButton={true} size={650} padding={"sm"} >
        <Flex align={'center'} justify={'center'} direction={"column"}>
          <Title order={3}>Add a Chart</Title>
          <Text align={'center'}> Add Chart to Your Dashboard</Text>
        </Flex>

        <Flex direction="column" gap="md" p={28} mih={""}>

          {/* Chart Type Select */}
          <Select
            width='100%'
            maxWidth='100%'
            className={`${styles.dropDown} ${styles.fullWidth}`}
            label="Chart Type"
            placeholder="Select chart type"
            data={allowedDataSources}
            value={chartType}
            onChange={setChartType}
          />

          {/* {chartType == 'accessibility_score_progress' && <LineChartOptionComponent />} */}
          {["vially_accessibility_overview"].includes(chartType ?? "") && <PieChartOptionComponent dataSource={chartType ?? ""} />}
          {
            chartType == 'issues_by_priority' && <PieChartOptionComponentPriority dataSource={chartType ?? ""} />
          }
          {chartType == 'vially_score' && <SemicircleOption />}
          {chartType == 'issues_count' && <MultipleBarHorizantalOption />}

          {["most_common_accessibility_issues", "most_common_success_criteria"].includes(chartType ?? "") && <BarChartOptionComponent dataSource={chartType ?? ""} />}



          {/* {chartType == 'GaugeChart' && <GaugeChartOptionComponent dataSource='compliance_score' />} */}
          {/* {["compliance_score", "accessibility_score"].includes(chartType ?? "") && <GaugeChartOptionComponent dataSource={chartType ?? ""} />} */}
          {["high_risk_websites", "best_ranking_website"].includes(chartType ?? "") && <WebsiteScoreChartOptionComponent dataSource={chartType ?? ""} />}

          {/* {chartType == 'total_issues_over_time' && <ScanProgressChartOptions />} */}
          {/* <Button type="submit" color='dark-green' fullWidth>Create A Chart</Button> */}
        </Flex>

        <Divider />
        <Flex justify={"end"} p={"sm"}>
          <Button color='gray-light' onClick={() => closeCreateChart()}>Close</Button>
        </Flex>
      </Modal>
      {/* Create chart */}

      <Modal close={closeDelete} opened={openedDelete} zIndex={1000} withCloseButton={false} size={416} padding={0}>
        <Group align={'center'} position={'center'} p={28}>
          <Title order={2}>Delete Dashboard</Title>
          <Text align={'center'}>
            Are you sure you want to delete This Dashboard </Text>
        </Group>
        <div className={classNames(styles['btn-group'])}>
          <UnstyledButton onClick={closeDelete} autoFocus={true} className={classNames(styles['action-btn'])}>
            {t('modalCancel')}
          </UnstyledButton>
          <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
          <UnstyledButton

            onClick={handleDeleteDashboard}
            aria-label='Delete Dashboard' className={classNames(styles['action-btn'], styles.btndelete)}>
            {t('modalDelete')}
          </UnstyledButton>
        </div>
      </Modal>

    </div>
  );


};

const PieChart = ({ warning, medium, low, high, critical }: { warning: number, medium: number, low: number, high: number, critical: number }) => {
  const data = {
    labels: ['Warning', 'Low', 'Medium', 'High', 'Critical'],
    datasets: [
      {
        data: [warning, low, medium, high, critical],
        backgroundColor: ['#DA604E', '#A3E6E1', '#2A2B4B', '#FF8C00', '#B22222'],
        borderWidth: .5,
      },
    ],
  };

  const options = {
    plugins: {
      datalabels: {
        display: false,
        color: '#fff'
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return `${context.label}: ${context.raw}%`;
          },
        },
      },
    },
  };

  return (
    <>

      <div style={{ width: '100%', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Doughnut width={"300"} data={data} options={options} />
      </div>
    </>
  );
};

export default SiteList;


type SiteListType = {
  siteUUID: string, score: number, name: string
}
interface DashboardTableRankingProps {
  webSitesData: Array<SiteListType>;
}



function DashboardTableRanking({ webSitesData }: DashboardTableRankingProps) {

  const data = webSitesData?.filter((site => site.score >= 50)) ?? []
  return (
    <table style={{
      border: "1px solid #ddd",
      borderCollapse: "collapse",
      width: '100%',
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
      backgroundColor: "#f9f9f9" // Light background for better readability
    }}>
      <thead>
        <tr style={{
          backgroundColor: "#f2f2f2", // Slightly darker background for header
          borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
        }}>
          <th style={{
            border: "1px solid #ddd",
            padding: "10px", // More padding for a spacious look
            textAlign: "left", // Align text to the left for default
            fontWeight: "bold" // Bold text for headers
          }}>Website Name</th>
          <th style={{
            border: "1px solid #ddd",
            padding: "10px",
            textAlign: "left"
          }}>Score</th>
        </tr>
      </thead>
      <tbody>
        {data?.length ? data.map((item: SiteListType, index) => (
          <tr
            key={item?.siteUUID}
            style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
            <td style={{
              border: "1px solid #ddd",
              padding: "10px" // Consistent padding
            }}>
              <Flex align={"center"} gap={"sm"} >
                <span style={{ width: '20px', height: '20px', background: '#035e11b0', borderRadius: '1rem' }}></span>
                <a href={item.name} target='_blank'>{item.name}</a>
              </Flex>
            </td>
            <td style={{
              padding: "10px",
              border: "1px solid #ddd"
            }}>{parseInt(String(item?.score))}%</td>
          </tr>
        )) :
          <tr>
            <td colSpan={5} style={{
              border: "1px solid #ddd",
              padding: "10px",
              textAlign: "center"
            }}>No data available</td>
          </tr>
        }
      </tbody>
    </table>
  )
}

function DashboardTableRankingRisk({ webSitesData }: DashboardTableRankingProps) {
  const data = webSitesData?.filter((site => site.score < 50)) ?? []
  return (
    <table style={{
      border: "1px solid #ddd", // Lighter border color for a softer look
      borderCollapse: "collapse",
      width: '100%',
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
      backgroundColor: "#f9f9f9" // Light background for better readability
    }}>
      <thead>
        <tr style={{
          backgroundColor: "#f2f2f2", // Slightly darker background for header
          borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
        }}>
          <th style={{
            border: "1px solid #ddd",
            padding: "10px", // More padding for a spacious look
            textAlign: "left", // Align text to the left for default
            fontWeight: "bold" // Bold text for headers
          }}>Website Name</th>
          <th style={{
            border: "1px solid #ddd",
            padding: "10px",
            textAlign: "left"
          }}>Score</th>
        </tr>
      </thead>
      <tbody>
        {data?.length > 0 ? data.map((item: SiteListType, index) => (
          <tr
            key={item?.siteUUID}
            style={{
              borderBottom: "1px solid #ddd" // Consistent border styling
            }}>
            <td style={{
              border: "1px solid #ddd",
              padding: "10px" // Consistent padding
            }}>
              <Flex align={"center"} gap={"sm"} >
                <span style={{ width: '20px', height: '20px', background: 'rgb(218, 96, 78)', borderRadius: '1rem' }}></span>
                <Link to={item.name} target='_blank'>{item.name}</Link>
              </Flex>
            </td>
            <td style={{
              padding: "10px",
              border: "1px solid #ddd"
            }}>{parseInt(String(item?.score))}%</td>
          </tr>
        )
        ) : <tr>
          <td colSpan={5} style={{
            border: "1px solid #ddd",
            padding: "10px",
            textAlign: "center"
          }}>No data available</td>
        </tr>
        }
      </tbody>
    </table>
  )
}


interface ScanProgessProps {
  issuesCountOverTime: {
    actual: Array<{
      date: string,
      totalIssues: number,
      closedIssues: number,
      openIssues: number
    }>
  }
}
function ScanProgressChart({ issuesCountOverTime }: ScanProgessProps) {

  const data = {
    labels: issuesCountOverTime?.actual.map(scan => scan.date),
    datasets: [
      {
        label: 'Total Issues',
        data: issuesCountOverTime?.actual.map(scan => scan.totalIssues),
        borderColor: '#2a2b4b',
        backgroundColor: '#2a2b4b',
        fill: false,
      },
      {
        label: 'Open Issues',
        data: issuesCountOverTime?.actual.map(scan => scan.openIssues),
        borderColor: '#035e11b0',
        backgroundColor: '#035e11b0',
        fill: false,
      },
      {
        label: 'Closed Issues',
        data: issuesCountOverTime?.actual.map(scan => scan.closedIssues),
        borderColor: '#035e11b0',
        backgroundColor: '#035e11b0',
        fill: false,
      },
      {
        label: 'New Issues',
        data: issuesCountOverTime?.actual.map(scan => scan.openIssues),
        borderColor: '#da604e',
        backgroundColor: '#da604e',
        fill: false,
      },
    ],
  };

  // Configure chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Total Issues Found by Automated Scan Over Time',
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Scan Date',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of Issues',
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '80%', margin: 'auto' }}>
        <Line data={data} options={options} />
      </div>

    </div>
  );
}